module.exports = __webpack_public_path__ + "media/svg/computer-b02ec228.svg";